import React from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../../helpers/ProjectList";
import "../../styles/ProjectDisplay.css";
import "../../styles/projects/SleepyWoods.css";
import Slider from "../../components/Slider";
import { sleepyWoodsImgs } from "../../helpers/SliderImages";

function SleepyWoods() {
  const { id } = useParams();
  const project = ProjectList[3];
  return (
    <div className="project">
      <div className="project-title">
        <h1 style={{ color: "#E9D35B" }}> {project.name}</h1>
      </div>
      <Slider mediaArray={sleepyWoodsImgs} />
      <div className="projectContent">
        <p>
          <b>Skills:</b> {project.skills}
        </p>
        <p>
          <b>Overview:</b> {project.overview}
        </p>
      </div>
    </div>
  );
}

export default SleepyWoods;
